if (!customElements.get('jjc-literary-door')) {
  class JJCLiteraryDoor extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reducedMotion) {
        this.style.setProperty('--door-open', 1);
        this.style.setProperty('--reveal', 1);
        this.style.setProperty('--story-open', 1);
        return;
      }

      this.update = this.update.bind(this);
      this.requestUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.requestUpdate);
      window.removeEventListener('resize', this.requestUpdate);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    clamp(value) {
      return Math.max(0, Math.min(1, value));
    }

    update() {
      const rect = this.getBoundingClientRect();
      const travel = Math.max(1, this.offsetHeight - window.innerHeight);
      const progress = this.clamp(-rect.top / travel);
      const doorOpen = this.clamp(progress / 0.32);
      const reveal = this.clamp((progress - 0.16) / 0.2);
      const storyOpen = this.clamp((progress - 0.48) / 0.3);
      this.style.setProperty('--door-open', doorOpen.toFixed(4));
      this.style.setProperty('--reveal', reveal.toFixed(4));
      this.style.setProperty('--story-open', storyOpen.toFixed(4));
    }
  }

  customElements.define('jjc-literary-door', JJCLiteraryDoor);
}
